import * as Common from '@/tenant/common';

export class PartneredUser extends Common.ObjectBase{
  constructor(){
    super('PartneredUserResult')
  }
  public tenantId:string;
  public tenantName:string;
  public userId:string;
  public userName:string;
}

export class PartneredUserQuery extends Common.LoadQuery {
  constructor(){
    super('PartneredUserQuery',PartneredUser);
  }
  public tenantId:string;
  public userId:string;
}
export class PartneredUserCreateQuery extends Common.Query{
  constructor(){
    super('PartneredUserCreateQuery',null);
  }
  public tenantId:string;
  public userId:string;
}
export class PartneredUserDeleteQuery extends Common.Query{
  constructor(items: Array<PartneredUser>){
    super('PartneredUserDeleteQuery',null);
    this.items = items;
  }
  public items : Array<PartneredUser>;
}
